import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrChannelPartnerWebhookEndpointStatus.ts
var t = () => e("channelPartnerWebhookEndpointStatus");
//#endregion
export { t as useTrChannelPartnerWebhookEndpointStatus };
